import { render } from "./PropertyDescription.vue?vue&type=template&id=7f32b7ad"
import script from "./PropertyDescription.vue?vue&type=script&lang=js"
export * from "./PropertyDescription.vue?vue&type=script&lang=js"

import "./PropertyDescription.vue?vue&type=style&index=0&id=7f32b7ad&lang=css"

import exportComponent from "/var/app/current/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__